import { Component, OnInit } from '@angular/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { switchMap, catchError, map } from 'rxjs/operators';
import { interval } from 'rxjs';
import { IBrand, IBrandHF } from '../common/ibrand';
import { RedactReplyServiceService } from '../service/redact-reply-service.service';
import { AppError } from '../common/class/app-error';
// import { of, Observable } from 'rxjs';
// import { map, catchError } from 'rxjs/operators';
import { SubSink } from '../../../node_modules/subsink';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { IDisappearingInkHF, IDisappearingInk, DisappearingInk } from '../class/DisappearingInk';
import { IPostResponseHF, IPostResponse, PostResponse } from '../class/PostResponse';
import { Router, ActivatedRoute } from '@angular/router';
import { timer, Subscription } from "rxjs";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
//import { stringify } from 'querystring';
import { IEmailVefifyHF, IEmailVefify, EmailVefify, IBrandDetailsHF, IBrandDetails, BrandDetails, CountryCodeDetails, ICountryCodeDetails, ICountryDialCodeForSenderAddress } from '../class/redact';
import { DestinationDetails } from '../class/DestinationDetails';
import { ResultContent } from '../class/AutoLockApiResponse';
import { AI_AutoLock_Access_Check } from '../service/AutoLock_Access_Check/AI_AutoLock_Access_Check';
import { AutoLockRequestModel } from '../class/AutoLockRequestModel';
import { SendAccessControlNoticeRequestModel } from '../class/SendAccessControlNoticeRequestModel';
import { Location } from '@angular/common';
import { AppConfigService } from '../app-config.service';
import { AutoLockRequestDecisionModel, AutoLockDecisionResponse, AccessDecision } from '../class/AutoLockAccess';
import { AccessDecisionService } from '../service/AccessDecisionService';
import { SessionStateService } from '../service/session-state.service';
import {AutolockSessionStateService} from '../service/Autolock-session-state.service';
import { CryptoService } from '../service/CryptoService';
import { GuidGenerator } from '../common/class/guid-generator';
import { BotCheckRequest,ResultContentData,BotApiResponse} from 'src/app/class/BotCheckRequest';
@Component({
  selector: 'app-encrypt-disappear-ink',
  templateUrl: './encrypt-disappear-ink.component.html',
  styleUrls: ['./encrypt-disappear-ink.component.scss']
})
export class EncryptDisappearInkComponent implements OnInit {
  // enableEdit: boolean = true;
  mySubscription: Subscription;
  logoId: string;
  public brandDetails = new BrandDetails;
  emailDispatchOption: number;
  isSMSOptionEnabled: boolean = false;
  DialCodeForSenderAddress: string;
  selectedLanguage: string;
  hideElement = false;
  destShortURL: string;
  HeaderHtml: SafeHtml;
  private subs = new SubSink();
  public copied = false;
  showLogo: boolean = false;
  companyLogoURL: string = "";
  countDown: Subscription;
  confidentialityStatement: string;
  counter: number;
  tick = 1000;
  subscription: Subscription;
  loading = false;
  submitted = false;
  loginForm: FormGroup;
  PasswordForm: FormGroup;
  invalidEmail: boolean;
  invalidPassword: boolean;
  sentPassword: boolean;
  isAutoLock_AccessDenied: boolean;
  accessDeniedText: string;
  isDisappearInk: boolean;
  contactSenderText: string;
  productLine: string;
  approvedByPasscode: boolean;
  ediinkRefUrl: string;
  featureType: string;
  themeValue: boolean;
  textValue: boolean;
  ActiveTabsKey: any;
  detectionKey: any;
    OpenActiveTabsKey : any;
  OpendetectionKey:any;
  AutolockActiveTabsKey: any;
  AutolockDetectionKey: any;
  crypto: CryptoService;
  deviceLogId: string = GuidGenerator.standard();
  IsDeviceFingerprintSettingEnabled: boolean = false;
   loader = true;              // Hide actual page
themeLoaded = false;         // Theme API completed
showSkeleton = false;        // Show skeleton only after theme is known

brandingLoaded = false;      // Branding API completed
destinationLoaded = false;
showContentLoader = false;
  constructor(private formBuilder: FormBuilder, private user: RedactReplyServiceService, private AI_Autolock_user: AI_AutoLock_Access_Check, private http: HttpClient, private router: Router, private route: ActivatedRoute
    , private translate: TranslateService, private location: Location, private accessDecisionService: AccessDecisionService,private sanitizer: DomSanitizer
    , private config: AppConfigService,private sessionState: SessionStateService,private AutolockSessionState: AutolockSessionStateService) {
    this.productLine = this.config.productLine;
    this.ediinkRefUrl = this.config.ediinkRefUrl;
    this.crypto = new CryptoService();
    this.route.params.subscribe(params => {
    this.destShortURL = params.shortURL;

    let languagedata = params.language.toString();

    if (this.destShortURL && this.destShortURL.endsWith('-pwd')) {
      // console.log('Approved By Passcode');

      // // Remove "-pwd"
      // languagedata = languagedata.substring(0, languagedata.length - 4);

      // this.approvedByPasscode = true;
       const encryptedValue = this.destShortURL.substring(0, this.destShortURL.length - 4);

        try {
          this.destShortURL = this.crypto.decryptQueryString(
            encryptedValue,
            this.config.preSetEncryptPwdKey,
            this.config.preSetEncryptPwdIVector
          );

          this.approvedByPasscode = true;
        } catch (e) {
          console.error('Decryption failed');
          this.approvedByPasscode = false;
          this.destShortURL = null;
        }
    } else {
      this.approvedByPasscode = false;
    }

    // Clean up language value
    languagedata = languagedata.replace(/[{}]/g, '');

    // Apply language
    this.translate.use(languagedata);

    localStorage.setItem('Language', languagedata);
    this.productLine = this.config.productLine;
    });
  }
  public verifyEmail: boolean = false;
  public verifyPassword: boolean = false;
  public verifyUser: boolean = false;
  public conditionvalue: number = 0;
  public DI = new DisappearingInk;
  //emailPattern="^(?!\\.)(?!\\')(?!\\^)(?!\\?)(?!\\])(?!\\*)(?!\\{)(?!\\})(?!\\[)(?!.*?[.]{2})|[#!_%&$^+-][a-z0-9.!#_%'&^$?!.\]*{}\[+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
  //emailPattern="^(?!.*?[.]{2})|[a-z0-9.!#_%'&^$?!.\]/*{}\[|/~=+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
  emailPattern = "^[a-zA-Z0-9.!#_%'&^$?\\-/+=]*[a-zA-Z0-9.!#_%'&^$?\\-/+=]+@[a-zA-Z\\u0080-\\uFFFF0-9_-]+\\.[a-zA-Z]{2,4}$";

  ngOnInit() {
      this.loader = true;
  this.themeLoaded = false;
  this.showSkeleton = false;
  this.brandingLoaded = false;
  this.destinationLoaded = false;
  this.showContentLoader=false;

     // this.translate.use(localStorage.getItem('Langauge'));
    // Initialize the destination details and result content objects
    var destDetails = new DestinationDetails();
    var resultContent = new ResultContent();

    // Detect client information
    this.detectClientInfo().then(clientInfo => {
      const { ipAddress, userAgent, referer, language } = clientInfo;
      console.log('Client Info:', ipAddress, userAgent, referer, language);

      const requestModel: BotCheckRequest = {
        IPAddress: ipAddress,
        ShortUrl: this.destShortURL,
        org: null,
        httpMethod: null,
        connection: null,
        httpUserAgent: null,
        secChUaModel: null,
        secChUaPlatform: null,
        msCv: null,
        Feature: 'Redact'
      };

      this.AI_Autolock_user.botCheck(requestModel).subscribe(result => {
        if (result == null || result.isBot) {
          window.location.href = 'about:blank';
          return;
        }

        // console.log('Skip Sending Alert:', result.skipSendingAlert);
        // console.log('Skip Reason:', result.skipReason);
        console.log('Is Bot:', result.isBot);
        this.getBrandingDetails();
                console.log('Is branding:', this.themeValue);
        // Get destination details independently
        this.AI_Autolock_user.getDestinationDetails(this.destShortURL, ipAddress, 'DisappearingInk').subscribe(
          destinationDetails => {
            if (destinationDetails) {
              destDetails.MessageId = destinationDetails.MessageId;
              destDetails.DestinationAddress = destinationDetails.DestinationAddress;
              destDetails.SenderAddress = destinationDetails.SenderAddress;
              destDetails.MessageLanguage = destinationDetails.MessageLanguage;
              destDetails.MessageSubject = destinationDetails.MessageSubject;
              destDetails.MessageCreatedDate = destinationDetails.MessageCreatedDate;
              this.featureType = 'DisappearingInk';
              this.ediinkRefUrl = this.ediinkRefUrl.replace('{shortURL}', this.destShortURL).replace('lang', destinationDetails.MessageLanguage);
              this.translate.use(destDetails.MessageLanguage);
              localStorage.setItem('Langauge', destDetails.MessageLanguage);
              this.IsDeviceFingerprintSettingEnabled = destinationDetails.DeviceFingerprintSetting;
              if (!this.approvedByPasscode && (destinationDetails.RequestStatus != 2) && !destinationDetails.IsExpired) {
                // Prepare auto lock request model
                const autoLockRequest: AutoLockRequestModel = {
                  IpAddress: ipAddress,
                  //IpAddress: "54.193.115.33",
                  SenderAddress: destDetails.SenderAddress,
                  RecipientAddress: destDetails.DestinationAddress,
                  //ProductLine: "RMail",
                  ProductLine: this.productLine,
                  ProductFeature: this.featureType,
                  ReferenceId: destDetails.MessageId,
                  Http_UserAgent: userAgent,
                  HTTP_Referer: referer,
                  Browser_Language: language,
                  RecipientType: 0,
                  RecipientMobile: null,
                  TransactionDate: destinationDetails.MessageCreatedDate,
                  AuditTrail: null,
                  Subject: destinationDetails.MessageSubject,
                  RecipientName: destinationDetails.DestinationName,
                  HttpMethod: null,
                  Language: destDetails.MessageLanguage,
                  IsPrimeEnvironment: !this.productLine || this.productLine.toLowerCase() !== 'rmail'
                };

                // Call auto lock access check
                this.AI_Autolock_user.getautoLockAccess(autoLockRequest).subscribe(
                  autoLockResponse => {
                    if (autoLockResponse && autoLockResponse.resultContent) {
                      resultContent = autoLockResponse.resultContent;
                      if (
                        resultContent &&
                        resultContent.autoLockRiskAnalysisData &&
                        resultContent.autoLockRiskAnalysisData.isBot === true
                      ) {
                        return null;
                      }
                      if (resultContent.lock) {
                        // Prepare access control notice request model
                        const accessControlNoticeRequest: SendAccessControlNoticeRequestModel = {
                          SenderAddress: destDetails.SenderAddress,
                          RecipientAddress: destDetails.DestinationAddress,
                          MessageId: destDetails.MessageId,
                          Location: `${resultContent.city}, ${resultContent.regionCode}`,
                          Country: resultContent.countryName,
                          Network: resultContent.network,
                          Feature: "RMail - Disappearing Ink",
                          OriginalSentDate: destDetails.MessageCreatedDate,
                          IpAddress: ipAddress,
                          ContinentCode: resultContent.continentCode,
                          AlertType: resultContent.riskLevel === 'Y' ? 'Yellow' : 'Red',
                          Language: destDetails.MessageLanguage,
                          Subject: destDetails.MessageSubject,
                          UserAgentRiskTextCode: resultContent.autoLockRiskAnalysisData.userAgentRiskTextCode,
                          AuditTrail: resultContent.autoLockRiskAnalysisData.auditTrail,
                          MatchedLegendTextCode: resultContent.autoLockRiskAnalysisData.matchedLegendTextCode,
                          CalculatedRiskType_Source: resultContent.autoLockRiskAnalysisData.calculatedRiskType_Source,
                          IsRiskAdjusted: resultContent.autoLockRiskAnalysisData.isRiskAdjusted,
                          AdjustedAlertType: resultContent.autoLockRiskAnalysisData.adjustedRiskLevel === 'Y' ? 'Yellow' : 'Red',
                          AlertReason: resultContent.autoLockRiskAnalysisData.alertReason
                        };
                        if (resultContent.enableRemovalRequest !== null && resultContent.enableRemovalRequest) {

                          if (destinationDetails.RequestStatus == 2) {
                            console.log('Access Control Notice will not be sent it is approved with status code:' + destinationDetails.RequestStatus);
                          }
                          else {
                            //console.log('Access Control Notice Sent');
                            (async () => {
                              await this.triggerDetectionAndNotifyAccess(this.destShortURL, resultContent.lockId, accessControlNoticeRequest, ipAddress);
                            })();
                          }
                          if (destinationDetails != null && destinationDetails.RequestStatus != null && destinationDetails.RequestsCount != null) {

                            if (destinationDetails.RequestStatus != 2) {

                              const accessDecision: AccessDecision = {
                                Id: destinationDetails.MessageId,
                                Feature: this.featureType,
                                Key: this.destShortURL,

                                Count: destinationDetails.RequestsCount,
                                Status: destinationDetails.RequestStatus,
                                Lang: destinationDetails.MessageLanguage,
                                RefUrl: this.ediinkRefUrl,

                                Theme: null,
                                Source: null,

                                hashedLockId: resultContent.lockId,
                                EMailDispatchOption: destinationDetails.EMailDispatchOption,
                                PhoneNumber: destinationDetails.PhoneNumber,
                                DestinationName: destinationDetails.DestinationName,
                                SenderAddress: destinationDetails.SenderAddress,
                                MessageSubject: destinationDetails.MessageSubject,
                                DestinationAddress: destinationDetails.DestinationAddress

                              };
                              this.accessDecisionService.setAccessDecision(accessDecision);
                              this.router.navigateByUrl('/requestaccess/DI');

                            }

                          }
                          if (destinationDetails != null && destinationDetails.RequestStatus == null && destinationDetails.RequestsCount == null) {

                            const accessDecision: AccessDecision = {
                              Id: destinationDetails.MessageId,
                              Feature: this.featureType,
                              Key: this.destShortURL,
                              Count: 0,
                              Status: 0,
                              Lang: destinationDetails.MessageLanguage,
                              RefUrl: this.ediinkRefUrl,
                              Theme: null,
                              Source: null,
                              hashedLockId: resultContent.lockId,
                              EMailDispatchOption: destinationDetails.EMailDispatchOption,
                              PhoneNumber: destinationDetails.PhoneNumber,
                              DestinationName: destinationDetails.DestinationName,
                              SenderAddress: destinationDetails.SenderAddress,
                              MessageSubject: destinationDetails.MessageSubject,
                              DestinationAddress: destinationDetails.DestinationAddress
                            };


                            this.accessDecisionService.setAccessDecision(accessDecision);

                            this.router.navigateByUrl('/requestaccess/DI');

                          }

                        }
                        else {
                          (async () => {
                            await this.triggerDetectionAndNotifyAccess(this.destShortURL, resultContent.lockId, accessControlNoticeRequest, ipAddress);
                          })();
                          this.isAutoLock_AccessDenied = true;
                          this.accessDeniedText = "Access Denied";
                          this.contactSenderText = "Please contact the sender for further information.";
                          this.isDisappearInk = true;
                          this.router.navigateByUrl(`/accessdenied/${this.destShortURL}` + "/DI");
                          return;

                        }
                      } else {
                        console.log('Access is allowed');
                        (async () => {
                          await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                        })();
                        this.verifyEmail = true;
                        this.PasswordForm = this.formBuilder.group({
                          password: ['', Validators.required]
                        });
                        this.loginForm = this.formBuilder.group({
                          // emailId: ['', Validators.required]
                          //emailId:  [null, [Validators.required, Validators.pattern(this.emailPattern), Validators.email]]
                          emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]]

                        });
                      }
                      if (!resultContent.enabled) {
                        console.log('Autolock feature is not enabled');
                        (async () => {
                          await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                        })();
                        this.verifyEmail = true;
                        this.PasswordForm = this.formBuilder.group({
                          password: ['', Validators.required]
                        });
                        this.loginForm = this.formBuilder.group({
                          // emailId: ['', Validators.required]
                          //emailId:  [null, [Validators.required, Validators.pattern(this.emailPattern), Validators.email]]
                          emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]]

                        });
                      }
                    }
                    else {
                      (async () => {
                        await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                      })();
                      this.verifyEmail = true;
                      this.PasswordForm = this.formBuilder.group({
                        password: ['', Validators.required]
                      });
                      this.loginForm = this.formBuilder.group({
                        // emailId: ['', Validators.required]
                        //emailId:  [null, [Validators.required, Validators.pattern(this.emailPattern), Validators.email]]
                        emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]]
                      });
                    }
                  },
                  error => {
                    console.error('Error during auto lock access check:', error);
                  }
                );
              }
              else {
                (async () => {
                  await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
                })();
                this.verifyEmail = true;
                this.PasswordForm = this.formBuilder.group({
                  password: ['', Validators.required]
                });
                this.loginForm = this.formBuilder.group({
                  // emailId: ['', Validators.required]
                  //emailId:  [null, [Validators.required, Validators.pattern(this.emailPattern), Validators.email]]
                  emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]]

                });
              }
            }
            else {
              (async () => {
                await this.triggerDetectionAndNotifyAccess(this.destShortURL, "", null, ipAddress);
              })();
              this.verifyEmail = true;
              this.PasswordForm = this.formBuilder.group({
                password: ['', Validators.required]
              });
              this.loginForm = this.formBuilder.group({
                // emailId: ['', Validators.required]
                //emailId:  [null, [Validators.required, Validators.pattern(this.emailPattern), Validators.email]]
                emailId: [null, [Validators.required, Validators.pattern(this.emailPattern)]]
              });}
           this.destinationLoaded = true;
              this.checkPageReady();
            },

            error => {
              console.error('Error getting destination details:', error);
              this.destinationLoaded = true;
              this.checkPageReady();
            }
        );
      });
    });
    //    this.getRedactTextView();
    //     this.countDown = timer(0, this.tick)
    //    .subscribe(() => --this.redact.TimeAllowed)
    //    this.mySubscription= interval(60000).subscribe((x =>{
    //      this.subs.sink = this.user.apiRedactTextViewDuration(this.logoId)
    //      .subscribe(resp => {
    //      });
    //  }));

    // this.sub = Observable.interval(10000)
    // .subscribe((val) => { console.log('called'); });
    // this.triggerOpenDetection();
  }
//DisappearingInk

  async triggerDetectionAndNotifyAccess(
    ShortURL: string,
    LockId: string,
    request: SendAccessControlNoticeRequestModel | null,
    ipAddress: string
  ): Promise<void> {
    //opendetection
    this.ActiveTabsKey = `edi_${this.destShortURL}_${ipAddress}`;
    this.detectionKey = `EDIODT_${this.destShortURL}_${ipAddress}`;
    //autolock opendetection
    this.OpenActiveTabsKey = `oedi_${this.destShortURL}_${ipAddress}`;
    this.OpendetectionKey = `OEDIODT_${this.destShortURL}_${ipAddress}`;
    //autolock
    this.AutolockActiveTabsKey = `Aedi_${this.destShortURL}`;
    this.AutolockDetectionKey = `AEDIODT_${this.destShortURL}`;
    var savedFingerprintDetails =false;
    //without autolock enabled
    if (!LockId && !request) {
      this.sessionState.setKeys(this.detectionKey, this.ActiveTabsKey);
      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();
        
        if(this.IsDeviceFingerprintSettingEnabled)
        {
          savedFingerprintDetails = await this.saveFingerprintDetails();
        }
        else{
          savedFingerprintDetails = true;
        }
        if (savedFingerprintDetails) {
          await this.triggerOpenDetection(ShortURL);
        }
        // return;
      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
    }
    //autolock enabled
    if (LockId && request) {
      this.sessionState.setKeys(this.OpendetectionKey, this.OpenActiveTabsKey);

      if (this.sessionState.isFirstVisit()) {
        this.sessionState.markVisited();
        const finalShortURL = `${ShortURL}@${LockId}`;
        
        if(this.IsDeviceFingerprintSettingEnabled)
        {
          savedFingerprintDetails = await this.saveFingerprintDetails();
        }
        else{
          savedFingerprintDetails = true;
        }
        if (savedFingerprintDetails) {
          await this.triggerOpenDetection(finalShortURL);
        }
        // return;
      } else {
        console.log('Open detection already triggered or new tab — skipping.');
      }
       this.AutolockSessionState.setKeys(this.AutolockActiveTabsKey, this.AutolockDetectionKey);
      if (this.AutolockSessionState.isFirstVisit()) {
        this.AutolockSessionState.markVisited();
        if (savedFingerprintDetails) {
          await this.sendAccessControlNotice(request);
        }
        // return;
      } else {
        console.log('sendAccessControlNotice already triggered or new tab — skipping.');
      }
    }
  }
  async triggerOpenDetection(id: string): Promise<void> {

    try {
if(!this.IsDeviceFingerprintSettingEnabled)
        {
          this.deviceLogId = "";
        }
      const success = await this.AI_Autolock_user
        .triggerOpenDetection(id, "DisappearingInk", this.deviceLogId)
        .toPromise();

      if (success) {
        console.log('Open detection triggered successfully');
      }
    }
    catch (error) {
      console.error('Error triggering open detection:', error);
    }
  }
  async saveFingerprintDetails(): Promise<boolean> {

    try {
      const encryptedFP = await (window as any) .collect();
      const success = await this.AI_Autolock_user. saveFingerprintDetails(this.deviceLogId, encryptedFP)
          .toPromise();

      if (success) {
         return true;
      }
       return false;
    }
    catch (error) {
      return true;
    }
  }
  async sendAccessControlNotice(request: SendAccessControlNoticeRequestModel): Promise<void> {
    try {
      const response = await this.AI_Autolock_user
        .sendAccessControlNotice(request)
        .toPromise();
      console.log('Access Control Notice Sent');
    }
    catch (error) {
      console.error('Error sending access control notice:', error);
    }
  }

  getDITextView(password: string) {
    this.subs.sink = this.user.postDITextView(this.destShortURL, password)
      // this.subs.sink = this.user.getDITextView(this.destShortURL)
      .subscribe(resp => {

        if (!(resp instanceof AppError)) {

          const response = resp as IDisappearingInkHF;
          const result = response.ResultContent;
          this.DI = result;
          // localStorage.setItem('redact', null);
          localStorage.setItem('disapperInk', JSON.stringify(this.DI));

          if (this.DI.LogoSrc == null || this.DI.LogoSrc == "") {
            this.showLogo = false;
          }
          else {
            this.showLogo = true;
            this.companyLogoURL = this.DI.LogoSrc;
          }
          this.confidentialityStatement = this.DI.ConfidentialityStatement;
          const source = interval(this.DI.TimeAllowed * 1000);
          this.subscription = source.subscribe(val => this.redirectToTimeRemaining());
          this.textValue=true;
          let count: number = 1;
          if (this.DI.DisappearingInkText != null) {
            // this.copyText=this.copyText.concat( this.DI.DisappearingInkCustomText );
            // this.copyText=this.copyText.concat(" :");
            //    this.copyText=this.copyText.concat('\n');
            //   this.copyText=this.copyText.concat(this.DI.DisappearingInkText);
            this.copyText = this.copyText.concat(this.DI.DisappearingInkText.toString().replace("<br/>", "\n"));
            this.copyText = this.copyText.concat('\n');
          }

          this.logoId = this.DI.LogId;
          if ((this.DI.ViewsLeft == "0") || (this.DI.IsDisappearingInkExpired == true)) {
            this.router.navigate(['DIviewRemaining'], { skipLocationChange: true });
          }
         this.showContentLoader = false;
        }
       },
      error => {
          this.showContentLoader = false;
      });

  }

  // async detectClientInfo(): Promise<{ ipAddress: string, userAgent: string, referer: string, language: string }> {
  //   const ipAddress = await this.getIpAddress();//"183.82.7.117";//
  //   const userAgent = navigator.userAgent;
  //   const referer = document.referrer;
  //   const language = navigator.language || (navigator as any).userLanguage;

  //   return { ipAddress, userAgent, referer, language };
  // }

  // getIpAddress(): Promise<string> {
  //   return this.http.get<{ ip: string }>('https://api64.ipify.org?format=json').pipe(
  //     map(response => response.ip)
  //   ).toPromise();
  // }

  async detectClientInfo(): Promise<{ ipAddress: string, userAgent: string, referer: string, language: string }> {
    const serverVariables = await this.AI_Autolock_user.getServerVariables().toPromise();

    if (serverVariables) {
      const { IPAddress, UserAgent, Referer, BrowserLanguage } = serverVariables;
      return {
        ipAddress: IPAddress || null,
        userAgent: UserAgent || null,
        referer: Referer || null,
        language: BrowserLanguage || null
      };
    } else {
      return {
        ipAddress: null,
        userAgent: null,
        referer: null,
        language: null
      };
    }
  }


  // get f() { return this.loginForm.controls; }
  get g() { return this.PasswordForm.controls; }
  redirectToTimeRemaining() {
    this.router.navigate(['DItimeRemaining'], { skipLocationChange: true });
  }
  public copyText: string = "";
  emailId: string;
  get f() { return this.loginForm.controls; }
  SendPassword() {
    if (this.loginForm.invalid) {
      this.invalidEmail = true;
      return;
    }
    this.user.postapiVerifyEmail(this.destShortURL, this.loginForm.value.emailId)
      .subscribe(resp => {
        const response = resp as IPostResponseHF;
        const result = response.ResultContent;
        let postResponse = result;
        if (response.Status == "Success" && postResponse.Verified.toString() == "true") {
          this.verifyEmail = false;
          this.verifyPassword = true;
          this.verifyUser = false;
          this.loading = true;
          this.invalidEmail = false;
          this.sentPassword = true;
        }
        else {
          this.invalidEmail = true;
          return;
        }
      })
  }
  VerifyPassword() {
    if (this.PasswordForm.invalid) {
      return;
    }
    this.user.postapiVerifyPassword(this.destShortURL, this.PasswordForm.value.password)
      .subscribe(resp => {
         this.showContentLoader = true;
        const response = resp as IPostResponseHF;
        const result = response.ResultContent;
        let postResponse = result;
        if (response.Status == "Success" && postResponse.Verified.toString() == "true") {
          if (postResponse.TTDT) {
          this.router.navigate(
              ['transactionTerminated'],
              { skipLocationChange: true }
          );
          return;
          }
          this.verifyEmail = false;
          this.verifyPassword = false;
          this.invalidPassword = false;
          this.sentPassword = false;
          this.verifyUser = true;
          this.submitted = true;
          this.getDITextView(this.PasswordForm.value.password);


         this.countDown = timer(0, this.tick)
  .subscribe(() => --this.DI.TimeAllowed);

if (this.DI.TimeAllowed > 0 && this.DI.ViewsLeft !== "0") {
  this.user.apiDITextViewDuration(this.logoId).subscribe();
}

        }
        else {
            this.showContentLoader = false;
          this.invalidPassword = true;
          this.sentPassword = false;
          return;
        }
      })
  }
  copyMessage() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.copyText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.copied = true;
    setTimeout(() => {                           //<<<---using ()=> syntax
      this.copied = false;
    }, 3000);
  }
getBrandingDetails() {

  this.subs.sink = this.user.postUserInformation(this.destShortURL, "DI")
    .subscribe(
      resp => {

        if (!(resp instanceof AppError)) {

          const response = resp as IBrandDetailsHF;
          this.brandDetails = response.ResultContent;

          // Theme
          this.themeValue = this.brandDetails.Theme != 2;

          localStorage.setItem('themeValue', JSON.stringify(this.themeValue));

          // Email/SMS option
          this.emailDispatchOption = this.brandDetails.EMailDispatchOption;
          this.isSMSOptionEnabled = this.emailDispatchOption == 2;

          // Get sender dial code if SMS is enabled
          if (this.isSMSOptionEnabled) {

            this.subs.sink = this.user
              .postCountryDialCodeForSenderAddress(this.destShortURL)
              .subscribe(resp => {

                if (!(resp instanceof AppError)) {

                  const response = resp as ICountryDialCodeForSenderAddress;
                  this.DialCodeForSenderAddress = response.DialCode;

                }

              });

          }

          // Logo
          if (this.brandDetails.LogoSrc == null || this.brandDetails.LogoSrc == "") {

            this.showLogo = false;

          }
          else {

            this.showLogo = true;
            this.companyLogoURL = this.brandDetails.LogoSrc;

          }

        }

        // Theme is known
        this.themeLoaded = true;

        // Show skeleton with correct theme
        this.showSkeleton = true;

        // Branding completed
        this.brandingLoaded = true;

        // Continue loading page
        this.checkPageReady();

      },
      error => {

        console.error(error);

        this.themeLoaded = true;
        this.showSkeleton = true;
        this.brandingLoaded = true;

        this.checkPageReady();

      });

}
  sanitizeHtml(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
   private checkPageReady(): void {
  if (this.brandingLoaded && this.destinationLoaded) {
     this.showSkeleton = false;
   setTimeout(() => {
      this.loader = false;
    }, 5000); // Test only

  }
}

}